import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  useMediaQuery,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material';

//import { DataGrid } from '@mui/x-data-grid';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { useStyle } from '../../context/styleContext/styleContext';
import {toast} from 'react-hot-toast'


export default function AdminUserDashboard() {
  const { style } = useStyle();
  const isMobile = useMediaQuery('(max-width:768px)');

  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [editOpen, setEditOpen] = useState(false);

  const fetchUsers = async () => {


const token = localStorage.getItem('token');
    try {
      const { data } = await axios.post('/admin/user_panel_info', { token });
      if (data.error) {
        toast.error(data.error);
      } else {
        setUsers(data.users)
        console.log(data.users)

      }
    } catch (error) {
      console.log(error);
    }
    //setIsLoading(false);


  };


useEffect(() => {
    fetchUsers();
  }, []);

  const handleEditClick = (user) => {
    setSelectedUser(user);
    setEditOpen(true);
  };


  const handleEditSave = async () => {

    const token = localStorage.getItem('token');
    if(!token)
    {
        return
    }

    await axios.post('/admin/edit_user_info',{token, selectedUser});
    setEditOpen(false);
    fetchUsers();
  };

  const handleInputChange = (field, value) => {
    setSelectedUser({ ...selectedUser, [field]: value });
  };

  
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [sortConfig, setSortConfig] = useState({ key: 'firstName', direction: 'asc' });
  const [columnWidths, setColumnWidths] = useState({});
  
  const handleColumnResize = (col, delta) => {
    setColumnWidths((prev) => ({
      ...prev,
      [col]: (prev[col] || 150) + delta
    }));
  };
  
  const sortedUsers = [...users].sort((a, b) => {
    const aVal = a[sortConfig.key]?.toString().toLowerCase() || '';
    const bVal = b[sortConfig.key]?.toString().toLowerCase() || '';
    if (aVal < bVal) return sortConfig.direction === 'asc' ? -1 : 1;
    if (aVal > bVal) return sortConfig.direction === 'asc' ? 1 : -1;
    return 0;
  });
  
  const filteredUsers = sortedUsers.filter((user) => {
    const query = searchQuery.toLowerCase();
    return (
      user.firstName?.toLowerCase().includes(query) ||
      user.lastName?.toLowerCase().includes(query) ||
      user.email?.toLowerCase().includes(query) ||
      user.userName?.toLowerCase().includes(query)
    );
  });
  
  const totalPages = Math.ceil(filteredUsers.length / itemsPerPage);
  const paginatedUsers = filteredUsers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  
  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };
  
  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };
  
  const handleSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };
  
  const columns = [
    { label: "Name", key: "firstName" },
    { label: "Username", key: "userName" },
    { label: "Email", key: "email" },
    { label: "Country", key: "country" },
    { label: "Admin", key: "isAdmin" }
  ];
  
  return (
    <Box sx={{ padding: 2, color: style.color4, backgroundColor:'black', minHeight: '100vh' }}>
      <Typography variant="h4" sx={{ mb: 1, color: style.color4 }}>User Management</Typography>
  
      {/* Stats Section */}
      <Grid container spacing={0.5} sx={{ mb: 1 }}>
        {[
          { label: 'Total Users', value: users.length },
          { label: 'Admins', value: users.filter(u => u.isAdmin).length },
          { label: 'Opted Into Email', value: users.filter(u => u.okToEmail).length },
          { label: 'Recently Active', value: users.filter(u => u.lastLogin).length }
        ].map((stat, i) => (
          <Grid item xs={12} sm={6} md={3} key={i}>
            <Card sx={{ backgroundColor: style.color2, color: style.color4, borderRadius: 2 }}>
              <CardContent>
                <Typography variant="h6">{stat.label}</Typography>
                <Typography variant="h4">{stat.value}</Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
  
      {/* Search Bar */}
      <TextField
        fullWidth
        placeholder="Search users..."
        variant="outlined"
        sx={{ mb: 2, backgroundColor: style.color3, input: { color: style.color1 } }}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
  
      {/* User Table */}
      <Table sx={{ backgroundColor: style.color2 }}>
        <TableHead>
          <TableRow>
            {columns.map((col, i) => (
              <TableCell
                key={i}
                onClick={() => handleSort(col.key)}
                sx={{
                  color: style.color4,
                  cursor: 'pointer',
                  userSelect: 'none',
                  width: columnWidths[col.key] || 150,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden'
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  {col.label} {sortConfig.key === col.key ? (sortConfig.direction === 'asc' ? '▲' : '▼') : ''}
                  <Box
                    sx={{ width: 10, cursor: 'col-resize' }}
                    onMouseDown={(e) => {
                      const startX = e.clientX;
                      const initialWidth = columnWidths[col.key] || 150;
                      const onMouseMove = (moveEvent) => {
                        const delta = moveEvent.clientX - startX;
                        handleColumnResize(col.key, delta);
                      };
                      const onMouseUp = () => {
                        document.removeEventListener('mousemove', onMouseMove);
                        document.removeEventListener('mouseup', onMouseUp);
                      };
                      document.addEventListener('mousemove', onMouseMove);
                      document.addEventListener('mouseup', onMouseUp);
                    }}
                  />
                </Box>
              </TableCell>
            ))}
            <TableCell sx={{ color: style.color4 }}>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody sx={{p:2}}>
          {paginatedUsers.map(user => (
            <TableRow size='small' key={user._id} sx={{marginBottom:'10px',backgroundColor:style.color1, filter:'brightness(1.2)'}}>
              <TableCell size='small' sx={{ color: style.color4, fontSize:'1.2rem', fontStyle:'bold', borderColor:style.color2, borderWidth:1, borderStyle:'solid' }}>{user.firstName} {user.lastName}</TableCell>
              <TableCell size='small' sx={{ color: style.color4, fontSize:'1.2rem', fontStyle:'bold', borderColor:style.color2, borderWidth:1, borderStyle:'solid'  }}>{user.userName}</TableCell>
              <TableCell size='small' sx={{ color: style.color4, fontSize:'1.2rem', fontStyle:'bold', borderColor:style.color2, borderWidth:1, borderStyle:'solid'  }}>{user.email}</TableCell>
              <TableCell size='small' sx={{ color: style.color4, fontSize:'1.2rem', fontStyle:'bold', borderColor:style.color2, borderWidth:1, borderStyle:'solid'  }}>{user.country}</TableCell>
              <TableCell size='small' sx={{ color: style.color4, fontSize:'1.2rem', fontStyle:'bold', borderColor:style.color2, borderWidth:1, borderStyle:'solid'  }}>{user.isAdmin ? 'Yes' : 'No'}</TableCell>
              <TableCell size='small' sx={{ color: style.color4, fontSize:'1.2rem', fontStyle:'bold', borderColor:style.color2, borderWidth:1, borderStyle:'solid'  }}>
                <Button
                  variant="outlined"
                  size='small'
                  sx={{ color: style.color4, borderColor: style.color4, '&:hover': { backgroundColor: style.color3 } }}
                  onClick={() => handleEditClick(user)}
                >
                  Edit
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
  
      {/* Pagination Controls */}
      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center', gap: 2 }}>
        <Button variant="outlined" onClick={handlePrevPage} disabled={currentPage === 1}>Previous</Button>
        <Typography sx={{ alignSelf: 'center' }}>Page {currentPage} of {totalPages}</Typography>
        <Button variant="outlined" onClick={handleNextPage} disabled={currentPage === totalPages}>Next</Button>
      </Box>
  
      {/* Edit Dialog */}
      <Dialog open={editOpen} onClose={() => setEditOpen(false)} fullWidth maxWidth="md">
        <DialogTitle sx={{color:style.color4, backgroundColor:style.color1}}>Edit User</DialogTitle>
        <DialogContent sx={{backgroundColor:style.color1}}>
          {[ 'userName', 'userNameLowerCase', 'email', 'emailLowerCase', 'stripeEmail', 'password', 'firstName', 'lastName', 'address1', 'address2', 'city', 'state', 'zip', 'country', 'phone' ].map(field => (
            <TextField
              key={field}
              label={field}
              fullWidth
              margin="dense"
              size="small"
              value={selectedUser?.[field] || ''}
              onChange={(e) => handleInputChange(field, e.target.value)}
              sx={{
                backgroundColor: style.color2,
                borderRadius:'4px',
                '& .MuiInputBase-input': {
                color: style.color4,  // Change the font color here
                fontSize: '16pt',  // Change the font size here
                boxShadow:5,
                                                
                },
                '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: style.color1, // Change the border color if needed
                    borderWidth:'2px'
                },
                '&:hover fieldset': {
                    borderColor: style.color1, // Change the border color on hover if needed\
                    borderWidth:'3px',                                                               
             
                    
                },
                '&.Mui-focused fieldset': {
                    borderColor: style.color1, // Change the border color when focused if needed
                    borderWidth:'3px'
                    
                },
                '&.Mui-disabled': {
                    '& fieldset': {
                    borderColor: style.color1, // Change the border color when disabled
                    },
                },
                },
                '& .MuiInputLabel-root': {
                color: style.color3, // Change the label color here
                fontSize:'14pt',
                },
                '& .MuiInputLabel-root.Mui-focused': {
                color: style.color3, // Change the label color when focused here                                 
                },
                '& .MuiInputLabel-root.Mui-disabled': {
                color: style.color2, // Change the label color when disabled
                },
                '& .MuiInputBase-root.Mui-disabled': {
                '& input': {
                    color: style.color3, // Change the input font color when disabled // so it works in safari
                    WebkitTextFillColor: style.color4, // so it works on chrome
                    fontSize:'14pt'
                },
                },
                '& .MuiOutlinedInput-input': { color: style.color4,
                '&:-webkit-autofill': { WebkitBoxShadow: '0 0 0 100px rgb(82, 109, 130) inset',
                    WebkitTextFillColor: style.color4, color:style.color4
                 }, }, 
            }}
            />
          ))}
          <TextField
            label="okToEmail"
            fullWidth
            margin="dense"
            size="small"
            value={selectedUser?.okToEmail ? 'true' : 'false'}
            onChange={(e) => handleInputChange('okToEmail', e.target.value === 'true')}
            sx={{
                backgroundColor: style.color2,
                borderRadius:'4px',
                '& .MuiInputBase-input': {
                color: style.color4,  // Change the font color here
                fontSize: '16pt',  // Change the font size here
                boxShadow:5,
                                                
                },
                '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: style.color1, // Change the border color if needed
                    borderWidth:'2px'
                },
                '&:hover fieldset': {
                    borderColor: style.color1, // Change the border color on hover if needed\
                    borderWidth:'3px',                                                               
             
                    
                },
                '&.Mui-focused fieldset': {
                    borderColor: style.color1, // Change the border color when focused if needed
                    borderWidth:'3px'
                    
                },
                '&.Mui-disabled': {
                    '& fieldset': {
                    borderColor: style.color1, // Change the border color when disabled
                    },
                },
                },
                '& .MuiInputLabel-root': {
                color: style.color3, // Change the label color here
                fontSize:'14pt',
                },
                '& .MuiInputLabel-root.Mui-focused': {
                color: style.color3, // Change the label color when focused here                                 
                },
                '& .MuiInputLabel-root.Mui-disabled': {
                color: style.color2, // Change the label color when disabled
                },
                '& .MuiInputBase-root.Mui-disabled': {
                '& input': {
                    color: style.color3, // Change the input font color when disabled // so it works in safari
                    WebkitTextFillColor: style.color4, // so it works on chrome
                    fontSize:'14pt'
                },
                },
                '& .MuiOutlinedInput-input': { color: style.color4,
                '&:-webkit-autofill': { WebkitBoxShadow: '0 0 0 100px rgb(82, 109, 130) inset',
                    WebkitTextFillColor: style.color4, color:style.color4
                 }, }, 
            }}
            
          />
          <TextField
            label="isAdmin"
            fullWidth
            margin="dense"
            size="small"
            value={selectedUser?.isAdmin ? 'true' : 'false'}
            onChange={(e) => handleInputChange('isAdmin', e.target.value === 'true')}
            sx={{
                backgroundColor: style.color2,
                borderRadius:'4px',
                '& .MuiInputBase-input': {
                color: style.color4,  // Change the font color here
                fontSize: '16pt',  // Change the font size here
                boxShadow:5,
                                                
                },
                '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: style.color1, // Change the border color if needed
                    borderWidth:'2px'
                },
                '&:hover fieldset': {
                    borderColor: style.color1, // Change the border color on hover if needed\
                    borderWidth:'3px',                                                               
             
                    
                },
                '&.Mui-focused fieldset': {
                    borderColor: style.color1, // Change the border color when focused if needed
                    borderWidth:'3px'
                    
                },
                '&.Mui-disabled': {
                    '& fieldset': {
                    borderColor: style.color1, // Change the border color when disabled
                    },
                },
                },
                '& .MuiInputLabel-root': {
                color: style.color3, // Change the label color here
                fontSize:'14pt',
                },
                '& .MuiInputLabel-root.Mui-focused': {
                color: style.color3, // Change the label color when focused here                                 
                },
                '& .MuiInputLabel-root.Mui-disabled': {
                color: style.color2, // Change the label color when disabled
                },
                '& .MuiInputBase-root.Mui-disabled': {
                '& input': {
                    color: style.color3, // Change the input font color when disabled // so it works in safari
                    WebkitTextFillColor: style.color4, // so it works on chrome
                    fontSize:'14pt'
                },
                },
                '& .MuiOutlinedInput-input': { color: style.color4,
                '&:-webkit-autofill': { WebkitBoxShadow: '0 0 0 100px rgb(82, 109, 130) inset',
                    WebkitTextFillColor: style.color4, color:style.color4
                 }, }, 
            }}
            
          />
          <TextField
            label="adminLevel"
            fullWidth
            margin="dense"
            type="number"
            size="small"
            value={selectedUser?.adminLevel || 0}
            onChange={(e) => handleInputChange('adminLevel', parseInt(e.target.value) || 0)}
            sx={{
                backgroundColor: style.color2,
                borderRadius:'4px',
                '& .MuiInputBase-input': {
                color: style.color4,  // Change the font color here
                fontSize: '16pt',  // Change the font size here
                boxShadow:5,
                                                
                },
                '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: style.color1, // Change the border color if needed
                    borderWidth:'2px'
                },
                '&:hover fieldset': {
                    borderColor: style.color1, // Change the border color on hover if needed\
                    borderWidth:'3px',                                                               
             
                    
                },
                '&.Mui-focused fieldset': {
                    borderColor: style.color1, // Change the border color when focused if needed
                    borderWidth:'3px'
                    
                },
                '&.Mui-disabled': {
                    '& fieldset': {
                    borderColor: style.color1, // Change the border color when disabled
                    },
                },
                },
                '& .MuiInputLabel-root': {
                color: style.color3, // Change the label color here
                fontSize:'14pt',
                },
                '& .MuiInputLabel-root.Mui-focused': {
                color: style.color3, // Change the label color when focused here                                 
                },
                '& .MuiInputLabel-root.Mui-disabled': {
                color: style.color2, // Change the label color when disabled
                },
                '& .MuiInputBase-root.Mui-disabled': {
                '& input': {
                    color: style.color3, // Change the input font color when disabled // so it works in safari
                    WebkitTextFillColor: style.color4, // so it works on chrome
                    fontSize:'14pt'
                },
                },
                '& .MuiOutlinedInput-input': { color: style.color4,
                '&:-webkit-autofill': { WebkitBoxShadow: '0 0 0 100px rgb(82, 109, 130) inset',
                    WebkitTextFillColor: style.color4, color:style.color4
                 }, }, 
            }}
            />
        </DialogContent>
        <DialogActions sx={{backgroundColor:style.color1}}>
          <Button onClick={() => setEditOpen(false)} sx={{borderColor:style.color4, color:style.color4 }}>Cancel</Button>
          <Button onClick={handleEditSave} variant="contained"  sx={{
                          backgroundColor: style.color1,
                          color: style.color4,
                          border: `1px solid ${style.color2}`,
                          width:'150px',
                          margin:'auto',
                          filter:'brightness(1.05)',
                          boxShadow:10,
                          fontWeight:'bold',
                          fontSize:'.8rem',
                          m:1,
                          "&:hover": { filter:'brightness(1.2)'},
                        }}>
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
  

}

